import { TFunction } from "i18next";
import { validateDOB } from "src/components/dob-input/dob-validation";
import { object, string } from "yup";

export const getValidationSchema = (t: TFunction) => {
  return object().shape({
    referenceNumber: string().required(t("landingPage.errors.referenceNumberRequired")),
    dobDay: string().label(t("personalDetails.labels.dobDay")).required(),
    dobMonth: string().label(t("personalDetails.labels.dobMonth")).required(),
    dobYear: string().label(t("personalDetails.labels.dobYear")).required(),
    dobCombined: string().test("dob-validation", "", function () {
      const { dobDay, dobMonth, dobYear } = this.parent;
      return validateDOB(dobDay, dobMonth, dobYear, t, this);
    }),
  });
};
